export default {
  methods: {
    InputFocus(data) {
      this.$sensors.track("InputFocus", data);
    },
    InputBlur(data) {
      this.$sensors.track("InputBlur", data);
    },
  },
};
